import { ClassTimes } from "src/components/items/ClassTimes";
import ClassModel from "src/models/ClassModel";
import PrivateSerieModel from "src/models/PrivateSerieModel";
import formatMoney from "src/utils/formatMoney";
import tw from "src/utils/tw";
import { Frequency } from "types/code-generator";

interface Props {
  privateSerie: PrivateSerieModel;
}

export function PrivateSerieRegistrationSettings(props: Props) {
  let frequency;
  let summary;
  let priceSummary = "";
  let icon = "far fa-box text-organization";
  let extensionSummary;
  const extensionEnabled = props.privateSerie?.offering?.allowExtension;

  if (props.privateSerie?.offering?.frequency === Frequency.OneTime) {
    frequency = "Flexible scheduling";

    priceSummary = `$${formatMoney(
      props.privateSerie.offering.price
    )} per session`;

    if (props.privateSerie.offering.allowExtension) {
      extensionSummary = `${props.privateSerie.accountOwner?.firstName} ${props.privateSerie.accountOwner?.lastName} may self-extend this registration`;

      if (props.privateSerie.offering.extensionMinAttendances) {
        extensionSummary += ` with a ${props.privateSerie.offering.extensionMinAttendances} session minimum.`;
      } else if (props.privateSerie.offering.package) {
        extensionSummary += ` by ${props.privateSerie.offering.extensionMinAttendances} sessions at a time.`;
      }
    } else {
      extensionSummary = `${props.privateSerie.accountOwner?.firstName} ${props.privateSerie.accountOwner?.lastName} may not self-extend this registration`;
    }
  } else if (props.privateSerie?.offering?.frequency === Frequency.Custom) {
    frequency = "Recurring";
    summary = `${props.privateSerie.numberOfLessons} sessions added each month`;
    priceSummary = `$${formatMoney(
      props.privateSerie.offering.price
    )} per session`;
  } else if (props.privateSerie?.offering?.frequency === Frequency.Monthly) {
    const classTimes = new ClassModel({
      classTimes: props.privateSerie.offering.classTimes,
    });
    frequency = "Recurring";
    summary = <ClassTimes classItem={classTimes} />;
    priceSummary = `$${formatMoney(
      props.privateSerie.offering.price
    )} per session`;
  }

  return (
    <div className="flex">
      <div className="mr-1 w-5 text-center">
        <i aria-hidden className={icon} />
      </div>
      <div>
        <div className="font-bold">{frequency}</div>
        <div className="text-sm">{priceSummary}</div>
        {extensionSummary && (
          <div
            className={tw(
              "mr-1 flex items-center text-sm",
              !extensionEnabled && "text-empty"
            )}
          >
            <i
              className={tw(
                "far fa-forward mr-1",
                extensionEnabled ? "text-organization" : "text-empty"
              )}
            />{" "}
            {extensionSummary}
          </div>
        )}

        <div className="text-sm">{summary}</div>
      </div>
    </div>
  );
}
